import 'normalize.css/normalize.css'
import 'react-notifications/lib/notifications.css'
import 'react-dates/lib/css/_datepicker.css'
import './styles/index.styl'

import React from 'react'
import { render } from 'react-dom'

import App from './App'

render(<App />, document.querySelector('#app'))



// WEBPACK FOOTER //
// ./src/index.js